module.exports = __webpack_public_path__ + "img/bg-cchsorteo-2026-mobile-2.b9e2a765.jpg";